import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-menu-support[closePopover]',
    templateUrl: './menu-support.component.html',
    styleUrls: ['./menu-support.component.scss'],
    standalone: true,
    imports: [TranslateModule, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuSupportComponent {
    closePopover = output<void>();

    readonly supportHubUrl = environment.supportHubUrl;
    readonly termsOfUseUrl = 'https://info.transnetyx.com/hubfs/Transnetyx%20Terms%20of%20Use.pdf';

    close(): void {
        this.closePopover.emit();
    }
}
